import { render } from "./EventLogUser.vue?vue&type=template&id=66466c31&scoped=true"
import script from "./EventLogUser.vue?vue&type=script&lang=js"
export * from "./EventLogUser.vue?vue&type=script&lang=js"

import "./EventLogUser.vue?vue&type=style&index=0&id=66466c31&lang=scss&scoped=true"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66466c31"]])

export default __exports__